import { Signal } from "typed-signals";

export class TotalBetControl {
    #totalBets;
    #currentIndex;

    onTotalBetChanged = new Signal();

    constructor(totalBets) {
        this.#totalBets = totalBets;
        this.#currentIndex = 0;
    }

    get totalBet() {
        return this.#totalBets[this.#currentIndex];
    }

    setTotalBet(value) {
        this.#currentIndex = this.#findClosestIndex(value);
    }

    nextTotalBet() {
        if (this.#currentIndex >= this.#totalBets.length - 1) return;
        this.#currentIndex++;
        this.onTotalBetChanged.emit(this.totalBet);
    }

    previousTotalBet() {
        if (this.#currentIndex <= 0) return;
        this.#currentIndex--;
        this.onTotalBetChanged.emit(this.totalBet);
    }

    #findClosestIndex(value) {
        if (this.#totalBets.length === 0) return 0;

        let closestIndex = 0;
        let minDiff = Math.abs(this.#totalBets[0] - value);

        for (let i = 1; i < this.#totalBets.length; i++) {
            const diff = Math.abs(this.#totalBets[i] - value);
            if (diff < minDiff) {
                minDiff = diff;
                closestIndex = i;
            }
        }

        return closestIndex;
    }
}
